import { FunctionComponent } from "react";

const Report: FunctionComponent = () => {
  return <>report page</>;
};

export default Report;